export const nameof = <T>(name: keyof T) => name;
export const nameofSecondLevel = <T, K>(firstLevelName: keyof T, secondLevelName: keyof K) => `${firstLevelName}.${secondLevelName}`;